<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="8.5"
      cy="8.5"
      r="7.5"
      stroke="url(#paint0_linear_2354_4430)"
      stroke-width="1.5"
      class="stroke"
    />
    <path
      d="M13.5 13.5L3.5 3.5"
      stroke="url(#paint1_linear_2354_4430)"
      stroke-width="1.5"
      class="stroke"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2354_4430"
        x1="8.5"
        y1="1"
        x2="8.5"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2354_4430"
        x1="8.5"
        y1="8.5"
        x2="9.20711"
        y2="7.79289"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
svg .stroke {
  stroke: #df252a;
}
</style>
